import { render } from "./customerDisplay.vue?vue&type=template&id=c0d7bb0c&scoped=true"
import script from "./customerDisplay.vue?vue&type=script&lang=js"
export * from "./customerDisplay.vue?vue&type=script&lang=js"

import "./customerDisplay.vue?vue&type=style&index=0&id=c0d7bb0c&scoped=true&lang=css"

import exportComponent from "D:\\Programming_And_Stuff\\Programming\\VueJs\\food-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0d7bb0c"]])

export default __exports__